import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, createVNode as _createVNode, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/imgcaptions/videoStart.svg'
import _imports_1 from '@/assets/imgcaptions/videoStop.svg'
import _imports_2 from '@/assets/imgcaptions/textBig.svg'
import _imports_3 from '@/assets/imgcaptions/textSmall.svg'
import _imports_4 from '@/assets/imgcaptions/backVideo.svg'


const _hoisted_1 = { class: "videoLargeInner" }
const _hoisted_2 = ["src"]
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "videoBoxText" }
const _hoisted_5 = { class: "videoRunBoxInner" }
const _hoisted_6 = { class: "videoRunTop" }
const _hoisted_7 = { class: "videoRunLine" }
const _hoisted_8 = { class: "videoRunTime" }
const _hoisted_9 = { class: "videoRunBtm" }
const _hoisted_10 = { class: "videoRunBtnBox" }
const _hoisted_11 = { class: "videoRunBtnRight" }

import { ref, onMounted, getCurrentInstance, reactive, nextTick, watch } from 'vue'
import sliderPoint from '@/components/common/sliderPoint'
// 时间处理方法
import { timeInfo, timeInfominute, timedata } from '@/components/public-method/time-method';
import {
    View,
    Hide,
} from "@element-plus/icons-vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'videoAmplify',
  props: {
    aUrl: String,
    isMp4: Boolean,
    startTime: Number,
    totalTime: Number,
    playShow: Boolean,
    cnText:String,
    enText:String,
},
  emits: ['closeAmplify','amplifyDrag','onOffPlay'],
  setup(__props, { emit: __emit }) {

let { proxy } = getCurrentInstance()
const props = __props
const audioRefs = ref()
const videoRefs = ref()
const Onoff=ref(false)
const videoRunShow=ref(false)
const controlsVisible = ref(false);
const hideTimer = ref(null);


// 显示控制栏并重置隐藏计时器
const showControls = () => {
  controlsVisible.value = true;
  videoRunShow.value = true;
  resetHideTimer();
};

// 重置隐藏计时器
const resetHideTimer = () => {
  if (hideTimer.value) {
    clearTimeout(hideTimer.value);
  }
  hideTimer.value = setTimeout(() => {
    controlsVisible.value = false;
    videoRunShow.value = false;
  }, 3000); // 3秒后隐藏
};

// 鼠标离开容器时开始隐藏计时器
const startHideTimer = () => {
  resetHideTimer();
};

const overContral=()=>{
    if (hideTimer.value) {
        clearTimeout(hideTimer.value);
        videoRunShow.value = true;
    }
}
const hideContral=()=>{
    if (hideTimer.value) {
        clearTimeout(hideTimer.value);
    }
    videoRunShow.value = false;
}
// 字幕放大
const textSize=ref(26)
const textSizeen=ref(18)
const textEnlarge = () =>{
    console.log('字幕放大')
    if(textSize.value<=36){
        textSize.value++
        textSizeen.value++
    }
}
const textShrink = () =>{
    if(textSize.value>=18){
        textSize.value--
        textSizeen.value--
    }
}
// 字幕显示隐藏
const textShow=ref(true)
const textToshow = () =>{
    textShow.value=true
    videoRunShow.value = true;
}
const textTohide = () =>{
    textShow.value=false
    videoRunShow.value = true;
}
onMounted(() => {
    Onoff.value=props.playShow
    if (props.isMp4) {
        videoRefs.value.currentTime = props.startTime/1000
        if (props.playShow) {
            videoRefs.value.play()
           
        }
    } else {
        audioRefs.value.currentTime = props.startTime/1000
        if (props.playShow) {
            audioRefs.value.play()
            
        }
    }
})
// watch(() => props.playShow, (n, o) =>{
//     console.log('检测'+ o)
// })
const emit = __emit
const closeVideo=()=>{
    emit('closeAmplify')
}
// 
const updataNumFun = (data) => {
    // console.log(data)
    if (props.isMp4) {
        videoRefs.value.pause()

    } else {
        audioRefs.value.pause()

    }

    // 视频跳转
    if (props.isMp4) {
        videoRefs.value.currentTime = data*props.totalTime/100000
        
    } else {
        audioRefs.value.currentTime = data*props.totalTime/100000
    }
    if (props.playShow) {
        if (props.isMp4) {
            videoRefs.value.play()

        } else {
            audioRefs.value.play()

        }
    }
    
    emit('amplifyDrag',data)
}
const rePlayThis=()=>{
    Onoff.value=!Onoff.value
    if(Onoff.value){
        if (props.isMp4) {
            videoRefs.value.play()
        } else {
            audioRefs.value.play()
        }
    }else{
        if (props.isMp4) {
            videoRefs.value.pause()

        } else {
            audioRefs.value.pause()

        }
    }
    emit('onOffPlay')
    
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "videoLarge",
    onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"])),
    onMouseout: hideContral
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "videoBox",
        onMousemove: showControls,
        onMouseleave: startHideTimer
      }, [
        (!props.isMp4)
          ? (_openBlock(), _createElementBlock("audio", {
              key: 0,
              src: _unref(proxy).getfileUrl + props.aUrl,
              ref_key: "audioRefs",
              ref: audioRefs,
              muted: ""
            }, null, 8, _hoisted_2))
          : _createCommentVNode("", true),
        (props.isMp4)
          ? (_openBlock(), _createElementBlock("video", {
              key: 1,
              src: _unref(proxy).getfileUrl + __props.aUrl,
              ref_key: "videoRefs",
              ref: videoRefs,
              muted: ""
            }, null, 8, _hoisted_3))
          : _createCommentVNode("", true),
        _withDirectives(_createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", {
            class: "cntext",
            style: _normalizeStyle({fontSize:textSize.value+'px'})
          }, _toDisplayString(props.cnText), 5),
          _createElementVNode("span", {
            class: "entext",
            style: _normalizeStyle({fontSize:textSizeen.value+'px'})
          }, _toDisplayString(props.enText), 5)
        ], 512), [
          [_vShow, textShow.value]
        ])
      ], 32),
      _withDirectives(_createElementVNode("div", {
        class: "videoRunBox",
        onMousemove: overContral
      }, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_unref(sliderPoint), {
                class: "videoRateLine",
                num: __props.startTime,
                max: __props.totalTime,
                onUpdataNum: updataNumFun
              }, null, 8, ["num", "max"])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("span", null, _toDisplayString(_unref(timeInfominute)(__props.startTime)), 1),
              _createElementVNode("span", null, _toDisplayString(_unref(timeInfominute)((__props.totalTime - __props.startTime))), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              (!Onoff.value)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: _imports_0,
                    alt: "",
                    class: "imgStyle",
                    onClick: _withModifiers(rePlayThis, ["stop"])
                  }))
                : _createCommentVNode("", true),
              (Onoff.value)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 1,
                    src: _imports_1,
                    alt: "",
                    class: "imgStyle",
                    onClick: _withModifiers(rePlayThis, ["stop"])
                  }))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("img", {
                src: _imports_2,
                alt: "",
                onClick: _withModifiers(textEnlarge, ["stop"])
              }),
              _createElementVNode("img", {
                src: _imports_3,
                alt: "",
                onClick: _withModifiers(textShrink, ["stop"])
              }),
              (!textShow.value)
                ? (_openBlock(), _createBlock(_unref(View), {
                    key: 0,
                    style: {"width":"2em","height":"2em","margin-right":"8px","color":"#fff"},
                    onClick: textToshow
                  }))
                : _createCommentVNode("", true),
              (textShow.value)
                ? (_openBlock(), _createBlock(_unref(Hide), {
                    key: 1,
                    style: {"width":"2em","height":"2em","margin-right":"8px","color":"#fff"},
                    onClick: textTohide
                  }))
                : _createCommentVNode("", true),
              _createElementVNode("img", {
                src: _imports_4,
                alt: "",
                onClick: _withModifiers(closeVideo, ["stop"])
              })
            ])
          ])
        ])
      ], 544), [
        [_vShow, videoRunShow.value]
      ])
    ])
  ], 32))
}
}

})